import { useContext, useState, useCallback } from "react";
import { EditableContext } from "../../common/EditableContextProvider";
import { Modal, Table } from "antd";
import { useDropzone } from "react-dropzone";
const { Column } = Table;

export const DocumentosModal = ({junior=false}) => {
    const { casos, documentos } = useContext(EditableContext);
    const [files, setFiles] = useState([]);
    const [descripcion, setDescripcion] = useState("");

    const onDrop = useCallback(acceptedFiles => {
        setFiles(prev => [...prev, ...acceptedFiles]);
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop, maxFiles: 20,
        multiple: true,
        accept: {}
    });
    const handle_submit = async (e) => {
        e.preventDefault();
        if (!files) { return; }
        await documentos.uploadDocumentos(descripcion, files);
        setDescripcion("");
        setFiles([]);
    }
    const handle_delete_documentos = async (item) => {
        await documentos.deleteDocumentos(item);
    }
    const reset = () => {
        setFiles([]);
    }

    return (
        <Modal
            title="Documentos"
            open={documentos.visibleModalDocumentos}
            onCancel={documentos.closeModalDocumentos}
            destroyOnClose={true}
            footer={null}
            width={900}
        >
            <div className="row">
                <div className="col-md">
                    <Table
                        size="small"
                        dataSource={casos.editItem.documentos}
                        rowKey="id"
                        scroll={{ y: 400, }}
                        pagination={{ position: [] }}
                        bordered
                    >
                        {
                            (!junior)? 
                            (<Column title="*" dataIndex="id" key="buttons" align="center"
                                width={30}
                                render={(value, row) => (
                                    <button className="btn btn-sm btn-outline-danger border"
                                        onClick={() => handle_delete_documentos(row)}
                                    >
                                        <span className="fas fa-trash"></span>
                                    </button>
                                )}
                            />):""
                        }
                        <Column title="ID" dataIndex="id" key="id" align="center" className="fw-bold"
                            width={80}
                            render={(value) => sprintf('%04d', value)}
                        />
                         <Column title="Descripción" dataIndex="descripcion" key="descripcion"
                            width={200}
                        />
                        <Column title="Descargar" dataIndex="path" key="path" align="center"
                            width={100}
                            render={(value) => (
                                <a className="btn btn-sm btn-light border"
                                    href={`/storage/${value}`}
                                    download="archivo">
                                    <span className="fas fa-download me-1"></span>
                                    Descargar
                                </a>
                            )}
                        />

                    </Table>
                </div>
                <div className="col-md-4">
                    <form onSubmit={(e) => handle_submit(e)}>
                        <fieldset disabled={documentos.loadingUploadDocumentos}>
                            <div className="mb-1">
                                <h5>Subir archivos</h5>
                                <small>Hasta 20 archivos.</small>
                            </div>
                            <div className='dropzone text-center mb-2' {...getRootProps()}>
                                <input name="drop" {...getInputProps()} />
                                {
                                    isDragActive ?
                                        <div className='w-100'>
                                            Suelta el archivo ZIP acá...
                                        </div> :
                                        <div className='w-100'>
                                            {
                                                ((files.length>0)) ? (
                                                    <div className="text-danger d-flex flex-column py-2" style={{ overflowY: 'auto', maxHeight: '200px' }}>
                                                        {
                                                            files.map((f, i) => (
                                                                <div key={i} className="d-flex">
                                                                    <span className="fas fa-file-zipper me-1"></span>
                                                                    {f.path}
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                ) : (<>Arrastra los archivos aquí, <br/>o haz click aquí.</>)
                                            }
                                        </div>
                                }
                            </div>
                            <div className="mb-2">
                                <label htmlFor="descripcion" className="form-label form-label-sm">
                                    Descripción
                                </label>
                                <textarea id="descripcion" name="descripcion" maxLength={300} 
                                    className="form-control" rows="2"
                                    value={descripcion}
                                    onChange={(e)=>setDescripcion(e.target.value)}
                                    required
                                ></textarea>
                            </div>
                            <div className="text-center">
                                <button className="btn btn-sm btn-outline-danger me-2" type="button"
                                    onClick={(e) => reset()}
                                >
                                    Reset
                                </button>
                                <button className="btn btn-sm btn-light border" type="submit">
                                    <span className="fas fa-upload me-1"></span>
                                    {
                                        (documentos.loadingUploadDocumentos) ?
                                            "Procesando..." : "Subir documentos"
                                    }
                                </button>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </Modal>
    );
}